import { Application } from "@hotwired/stimulus"
import DatepickerController from "./datepicker_controller"

const application = Application.start()
application.register("datepicker", DatepickerController)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
